<template>
    <div>
        <h2>Nombre de participations</h2>
        <input type="text" class="result blue1" :value='chartDatas.total_participants' disabled >

        <h2>Nombre de joueurs uniques</h2>
        <input type="text" class="result blue2" :value='chartDatas.unique_participants' disabled >

        <h2>Moyenne de participations par joueur</h2>
        <input type="text" class="result blue3" :value='chartDatas.average_participants' disabled >

        <h2>Nombre de participations gagnantes</h2>
        <input type="text" class="result blue4" :value='chartDatas.total_winners' disabled >

        <h2>Nombre de Opt-in sur participation unique</h2>
        <input type="text" class="result blue5" :value='chartDatas.unique_optins' disabled >
    </div>
</template>
<script>

  export default {
    props: {
        chartDatas: { type: Object, required: false, default: function () { return {} }},
    }
  }
</script>

<style lang="scss">
    .result {
        text-align: center;
        color:white;
        font-size: 20px;
        font-weight: bold;
       }
</style>

